import { isArray } from 'lodash';
import Translation from '@/services/Translation';

export default (http, store, router) => {
    // https://github.com/mzabriskie/axios#interceptors
    http.interceptors.response.use(

        response => response,

        /*
         * This is a central point to handle all
         * error messages generated by HTTP
         * requests
         */
        (error) => {
            const {response} = error;

            if (typeof response !== 'undefined') {
                // If token is either expired, not provided or invalid then redirect to login.
                if ([401, 400].indexOf(response.status) > -1) {
                    // Don't show leaving page confirmation
                    if (typeof router.currentRoute.meta.submit !== "undefined"
                        && router.currentRoute.meta.submit === false
                    ) {
                        router.currentRoute.meta.submit = true;
                    }

                    router.push({name: 'auth.login'});
                }

                // User is authenticated but authorization for a requested action failed
                if (response.status === 403) {
                    // Don't show leaving page confirmation
                    if (typeof router.currentRoute.meta.submit !== "undefined"
                        && router.currentRoute.meta.submit === false
                    ) {
                        router.currentRoute.meta.submit = true;
                    }

                    store.dispatch('swalToast', {
                        type: 'error',
                        message: Translation.get('exceptions.authorization_page', null, store.state.system_locale)
                    });
                    router.push({name: 'dashboard.index'});
                } else if (response.status === 503) {
                    // Don't show leaving page confirmation
                    if (typeof router.currentRoute.meta.submit !== "undefined"
                        && router.currentRoute.meta.submit === false
                    ) {
                        router.currentRoute.meta.submit = true;
                    }

                    // Reload if is maintenance mode
                    window.location.reload(true);
                } else {
                    if (isArray(response.data.messages)) {
                        // Errors are sent in arrays
                        store.dispatch('swalToast', {type: 'error', message: response.data.messages});
                    } else {
                        // Laravel generated validation errors are sent in an object
                        store.dispatch('setMessage', {type: 'validation', message: response.data});
                        // Show hint for validation, but not on login page
                        if (response.status === 422
                            && (router.currentRoute.fullPath !== '/' && router.currentRoute.fullPath !== '/login')
                        ) {
                            store.dispatch('swalToast', {
                                type: 'warning',
                                message: Translation.get(
                                    'messages.warning.has_validation_messages',
                                    null,
                                    store.state.system_locale
                                ),
                                timer: 3000
                            });
                        }
                    }
                }
            }

            store.dispatch('setFetching', false);

            return Promise.reject(error);
        }
    );
};



// WEBPACK FOOTER //
// ./src/plugins/http/interceptors.js